/** One ignition verdict for Codec 8 IO values in gateway and diagnostics. */
export const IO_IGNITION_DIN1 = 1;
export const IO_IGNITION_GENERIC = 239;

export function decodeIgnitionIo(values: ReadonlyMap<number, bigint>): boolean | null {
  for (const ioId of [IO_IGNITION_DIN1, IO_IGNITION_GENERIC]) {
    const raw = values.get(ioId);
    if (raw === 1n) return true;
    if (raw === 0n) return false;
  }
  return null;
}
